/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const ingredientPreference = useStore((state) => state.ingredientPreference);
  const setIngredientPreference = useStore((state) => state.setIngredientPreference);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.ingredientPreference.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={ingredientPreference}
          onChange={(value) => {
            setIngredientPreference(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'ingredient-preference',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'simple'}>
            <span>🍳</span> {t('onboarding.ingredientPreference.options.simple')}
          </Option>
          <Option value={'balanced'}>
            <span>🥑</span> {t('onboarding.ingredientPreference.options.balanced')}
          </Option>
          <Option value={'premium'}>
            <span>🧈</span> {t('onboarding.ingredientPreference.options.premium')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
